export const portfolioData = {
  personalInfo: {
    name: "Tyler Cartwright",
    title: "Machine Learning Engineer",
    email: "tylercartwright2606@gmail.com",
    location: "United Kingdom",
    tagline: "Turning data science into production systems that scale. Specialising in ML engineering, cloud infrastructure, and intelligent fraud detection.",
    links: {
      github: "https://github.com/tyler-carty",
      linkedin: "https://linkedin.com/in/tyler-reece-cartwright",
    }
  },

  experience: [
    {
      id: 4,
      company: "Lloyds Banking Group",
      role: "Machine Learning Engineer",
      period: "Jan 2026 - Present",
      location: "United Kingdom",
      team: "Economic Crime Prevention Platform",
      description: "Joined as the team's first Machine Learning Engineer, bridging the gap between data science experimentation and production-grade systems across multiple model sub-teams.",
      achievements: [
        "Owns the team's shared Python utilities package, standardising workflows across model sub-teams, eliminating duplicated effort, and giving engineers cross-team visibility of model development patterns",
        "Productionising fraud detection models on GCP Vertex AI by translating notebook experiments into industry-standard pipelines, enabling scalable, auditable batch inference at production scale"
      ],
      technologies: ["Python", "GCP", "Vertex AI", "Machine Learning"]
    },
    {
      id: 1,
      company: "Lloyds Banking Group",
      role: "Data Scientist",
      period: "May 2025 - Jan 2026",
      location: "United Kingdom",
      team: "Economic Crime Prevention Platform",
      description: "Led data science initiatives to combat financial crime through advanced analytics and machine learning.",
      achievements: [
        "Developed two machine learning models for AML and fraud detection",
        "Improved fraud detection rates by 50% per model without increasing alert volume",
        "Generated £100,000 in additional recovered funds per model each month"
      ],
      technologies: ["Python", "Machine Learning", "Data Analytics", "GCP"]
    },
    {
      id: 2,
      company: "Lloyds Banking Group",
      role: "Data Engineer",
      period: "Sept 2024 - May 2025",
      location: "United Kingdom",
      team: "Economic Crime Prevention Platform",
      description: "Built and maintained data infrastructure supporting fraud detection systems.",
      achievements: [
        "Designed and implemented ETL pipelines processing millions of transactions daily",
        "Introduced over 100 new data points to the data warehouse, directly improving the accuracy of the models",
        "Optimised Spark applications for performance and cost efficiency, saving £500,000 per year"
      ],
      technologies: ["Python", "SQL", "Apache Spark", "GCP", "Data Warehousing"]
    },
    {
      id: 3,
      company: "Lloyds Banking Group",
      role: "Cloud Software Engineer (Internship)",
      period: "June 2022 - Sept 2023",
      location: "United Kingdom",
      team: "Homes Platform",
      description: "Contributed to cloud-native applications supporting mortgage services.",
      achievements: [
        "Developed incident detection systems within Azure to reduce response times from hours to minutes",
        "Migrated a central microservices application to Azure to improve scalability and reliability",
        "Automated health checks and alerting systems to reduce application downtime by 50%"
      ],
      technologies: ["Javascript", "Azure", "Docker", "Kubernetes", "CI/CD"]
    }
  ],

  freelanceExperience: [
    {
      id: 1,
      client: "Hodsock Priory & Prestwold Hall",
      project: "Staff Management System",
      period: "June 2024 - May 2025",
      description: "Developed a comprehensive staff management platform for event venues.",
      achievements: [
        "Built full-stack web application to handle shift tracking and payroll management",
        "Implemented role-based access control and automated reporting",
        "Reduced administrative overhead by 95% through automation of manual tasks"
      ],
      technologies: ["React", "Node.js"]
    }
  ],

  projects: [
    {
      id: 6,
      title: "Production ML Systems",
      category: "Work",
      description: "Established ML platform foundations as the team's first Machine Learning Engineer — owning a shared Python utilities package adopted across model sub-teams and productionising fraud detection models through cloud-native ML pipelines on Vertex AI.",
      technologies: ["Python", "GCP", "Vertex AI", "Machine Learning"],
      github: null,
      demo: null,
      featured: true
    },
    {
      id: 1,
      title: "Staff Management System",
      category: "Freelance",
      description: "Full-stack staff scheduling and management platform for event venues. Features include shift scheduling, automated reporting, and mobile-responsive design.",
      technologies: ["React", "Node.js"],
      github: null,
      demo: null,
      featured: true
    },
    {
      id: 2,
      title: "Economic Crime ML Models",
      category: "Work",
      description: "Machine learning models for fraud detection and prevention, processing millions of transactions daily.",
      technologies: ["Python", "Machine Learning", "Data Analytics", "GCP"],
      github: null,
      demo: null,
      featured: true
    },
    {
      id: 3,
      title: "Data Pipeline Architecture",
      category: "Work",
      description: "Scalable ETL pipelines for real-time transaction monitoring and data warehousing.",
      technologies: ["Java", "SQL", "Apache Spark", "GCP", "Data Warehousing"],
      github: null,
      demo: null,
      featured: true
    },
    {
      id: 4,
      title: "Portfolio Website",
      category: "Personal",
      description: "Modern, responsive portfolio website built with React and Tailwind CSS.",
      technologies: ["React", "Tailwind CSS", "Framer Motion"],
      github: "https://github.com/tyler-carty/tyler-carty.github.io",
      demo: "https://tylercartwright.co.uk",
      featured: false
    },
    {
      id: 5,
      title: "WaniKani Statistics Tracker",
      category: "Educational",
      description: "A web application to track and visualise WaniKani progress. Shared with thousands of users to help them track their progress and stay motivated.",
      technologies: ["TypeScript", "PWA", "Github Actions"],
      github: "https://github.com/tyler-cartwright/wanikani-stats-tracker",
      demo: "https://tyler-cartwright.github.io/wanikani-stats-tracker/",
      featured: false
    }
  ],

  skills: {
    languages: ["Python", "JavaScript", "TypeScript", "Java", "SQL"],
    cloud: ["GCP", "Vertex AI", "Azure", "Docker", "Kubernetes", "Terraform"],
    dataScience: ["Machine Learning", "Scikit-learn", "LightGBM", "PyTorch"],
    dataEngineering: ["Apache Spark", "BigQuery", "ETL Pipelines", "Data Warehousing"],
    webDevelopment: ["React", "Node.js", "Express", "REST APIs"],
    tools: ["Git", "CI/CD", "Jenkins", "GitHub Actions", "JIRA", "Agile/Scrum"]
  },

  education: [
    {
      id: 1,
      institution: "University of Derby",
      degree: "BSc Computer Science",
      grade: "First Class Honours",
      period: "2020 - 2024",
      achievements: [
        "Dean's Award recipient (all years)",
        "Specialised in Machine Learning and Data Science",
        "Final year project: Sentiment analysis using Reddit data surrounding the GameStop and AMC stock craze"
      ]
    }
  ]
};

export default portfolioData;
